import type { PointInTimeEarnings } from '../../earnings';

export function oneMinuteTicks(chart_data: PointInTimeEarnings[]): number[] {
  const simulationLength = Math.max(...chart_data.map((data) => data.seconds));
  const ticks: number[] = [];
  for (let i = 0; i <= simulationLength; i += 60) {
    ticks.push(i);
  }
  return ticks;
}

export const formatSeconds = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const formatValue = (value: number): string => {
  if (value >= 1e6) return `${(value / 1e6).toFixed(1)}M`;
  if (value >= 1e3) return `${(value / 1e3).toFixed(1)}K`;
  return value.toString();
};
